import { Button, Drawer, Image, message, Skeleton } from 'antd'
import { addCommasToNumber } from 'helpers'
import handle from 'services/Axios'
import SWR_KEY from 'services/swr/constant'
import { useGetCheckedIn, useGetCheckInList, useGetMe } from 'services/swr/user'
import { TokenType, useTokenStore } from 'state/useTokenStore'
import { useTranslation } from 'translations'
import { formatUnits } from 'utils'
import useSWRMutation from 'swr/mutation'
import moment from 'moment'
import { twMerge } from 'tailwind-merge'

const AloDrawer = ({ onClose, open }) => {
  const { data } = useGetMe()
  const { t } = useTranslation()

  return (
    <Drawer
      title={<p className='text-center font-bold text-xl'>{t('ALO POWER')}</p>}
      placement='bottom'
      className='container !px-0'
      closable={false}
      onClose={onClose}
      height='50%'
      open={open}
      key='set-network'
    >
      <div className='flex flex-col gap-3'>
        <div className='flex flex-col gap-2'>
          <div className='flex flex-col items-center gap-2'>
            <p className='text-secondary text-center text-lg'>{t('Total ALO Balances')}</p>
            <p className='text-2xl font-bold text-center'>
              {!data ? '--' : addCommasToNumber(formatUnits(data.token_alo.balance, +data.token_alo.decimals))}
              <Image
                preview={false}
                src='/images/logo/main-logo.svg?v=1.4'
                alt='coin'
                className='object-cover !w-6 !h-6 rounded-[100%] ml-2 relative bottom-[2px]'
              />
            </p>
          </div>
        </div>

        <p className='font-bold text-base'>{t('Free ALO daily')}</p>
        <CheckInList />
      </div>
    </Drawer>
  )
}

export default AloDrawer

export const CheckInList = () => {
  const { t } = useTranslation()

  const tokenList = useTokenStore((s) => s.tokenList)
  const { data } = useGetCheckInList()
  const { data: checkedData, mutate } = useGetCheckedIn()
  const { mutate: refreshBalance } = useGetMe()

  const { trigger, isMutating } = useSWRMutation(SWR_KEY.CHECKED_IN, async (url) => {
    try {
      await handle.post(url)
      await mutate()
      await refreshBalance()
      message.success('Check in Successfully')
    } catch (error: any) {
      message.error(error.message)
    }
    return
  })

  return (
    <div className='flex flex-nowrap gap-2 overflow-x-scroll w-full pb-4'>
      {!tokenList || !data || !checkedData ? (
        <Skeleton.Node active className='!w-full !h-[132px]' />
      ) : (
        data.map((bonus, index) => {
          const token = tokenList.find((t) => t.symbol === bonus.reward_unit) as TokenType

          return (
            <div
              className={twMerge(
                'flex flex-col items-center gap-2 border-solid border-[1px] rounded-2xl border-primary px-2 py-3 min-w-[110px]',
                index < checkedData.length && 'bg-[#cdffd0]'
              )}
              key={bonus.id}
            >
              <p className='text-center text-xs font-bold'>
                {t('Day')} {bonus.id}
              </p>

              <Image preview={false} src='/images/logo/main-logo.svg?v=1.4' className='!w-10 rounded-full object-cover' />
              <Button
                type='primary'
                className={twMerge(
                  '!h-5 text-[10px] w-full',
                  bonus.day_number < checkedData?.next_checkin_day_number &&
                    '!bg-transparent !text-primary !border-none !font-bold'
                )}
                disabled={
                  checkedData?.next_checkin_day_number !== bonus.day_number ||
                  moment.utc().isSame(moment.utc(checkedData?.last_checked_in_date, 'YYYY-MM-DD'), 'day')
                }
                loading={isMutating}
                onClick={() => trigger()}
              >
                +{formatUnits(bonus.reward_amount, +token.decimals as number)} ALO
              </Button>
            </div>
          )
        })
      )}
    </div>
  )
}
